import { axiosGet, axiosPost } from "../../react_axios/Axios";
import {
  headers,
  getCartListUrl,
  GET_CART_LIST,
} from "../../utils/constants";

export const getCartList_action = (userID, memberID) => async (dispatch) => {
  try {
    const mapdata = {
      UserID: userID,
      MemberID: memberID,
      token: "token",
    };
    const res = await axiosGet(getCartListUrl, mapdata, headers);

    dispatch({
      type: GET_CART_LIST,
      payload: res,
    });

    return Promise.resolve(res);
  } catch (err) {
    return Promise.reject(err);
  }
};
